import React from 'react';
import ApexCharts from 'react-apexcharts';

const SupportChart = ({ data, categories }) => {
  const options = {
    chart: {
      type: 'area',
      height: 250,
      toolbar: { show: false },
      zoom: { enabled: false },
      parentHeightOffset: 0,
    },
    colors: ["#4680ff"],
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.05,
        stops: [0, 90, 100],
      },
    },
    dataLabels: { enabled: false },
    grid: {
      borderColor: '#f1f1f1',
      strokeDashArray: 4,
      padding: {
        top: 10,
        right: 10,
        bottom: 0,
        left: 10,
      },
    },
    xaxis: {
      categories: categories || [],
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        formatter: (val) => `₹${val >= 1000 ? (val / 1000).toFixed(0) + 'k' : val}`,
      },
      forceNiceScale: true,
    },
    tooltip: {
      y: {
        formatter: (val) => `₹${val.toLocaleString('en-IN')}`,
      },
    },
  };

  const series = [{ name: 'Sales', data: data || [] }];

  return (
    <div className="chart-container" style={{ overflow: "hidden", width: "100%" }}>
      <ApexCharts options={options} series={series} type="area" height={250} />
    </div>
  );
};

export default SupportChart;